import {TaskCategory} from '@modifi/enums'

export const docUpoadCategories = [
  TaskCategory.COMPANY_FINANCIAL_REVIEW,
  TaskCategory.COMPANY_GROUP_FINANCIAL_REVIEW,
  TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_HIGH_AMOUNT_APPLICATION,
]

export const bsrLimitsCategories = [
  TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_FOLLOW_UP,
  TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_REALLOCATION,
  TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_UPDATE_APPLICATION,
  TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_HIGH_AMOUNT_APPLICATION,
  TaskCategory.TRADE_PARTNER_INSURANCE_LIMIT_MEDIUM_AMOUNT_APPLICATION,
  'TRADE_PARTNER_ALLOCATED_LIMIT_CHANGE_REQUEST',
]
